import type { SVGProps } from "react";
export interface DogLeashIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function DogLeashIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: DogLeashIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M8.875 16.5V10q.002-.238.09-.444l-6.76-6.76-.078-.085A1.125 1.125 0 0 1 3.71 1.127l.087.078 7.87 7.87 5.836 2.918.102.057a1.126 1.126 0 0 1-1.001 2.003l-.105-.047-5.374-2.687V16.5a1.125 1.125 0 0 1-2.25 0m-8-8a1.125 1.125 0 0 1 2.25 0c0 .713.399 1.335.987 1.652l.263.117.106.044a1.125 1.125 0 0 1-.745 2.11l-.111-.033-.295-.117A4.13 4.13 0 0 1 .875 8.5m15.627-3.125.116.006a1.125 1.125 0 0 1 0 2.238l-.116.006h-.004a1.125 1.125 0 1 1 0-2.25z"
      />
      <path
        fill={color}
        d="M20.875 6.625H19.5c-.354 0-.687-.167-.9-.45l-.9-1.2a.88.88 0 0 0-.7-.35h-3.5q-.099-.001-.193-.019l-.69 5.534c-.07.563-.55.984-1.117.985H8A3.876 3.876 0 0 0 4.125 15v5.5c0 .207.168.375.375.375h1a.375.375 0 0 0 .375-.375v-2A3.124 3.124 0 0 1 9 15.376h2a3.125 3.125 0 0 1 3.126 3.124v2c0 .207.167.375.375.375h.998a.375.375 0 0 0 .375-.375v-7.69A3.126 3.126 0 0 1 18.69 9.7l.497-.05.178-.025a1.876 1.876 0 0 0 1.511-1.84v-1.16Zm2.25 1.16a4.126 4.126 0 0 1-3.325 4.047l-.39.057-.497.05a.876.876 0 0 0-.788.872V20.5a2.625 2.625 0 0 1-2.626 2.625h-.998a2.625 2.625 0 0 1-2.625-2.625v-2a.875.875 0 0 0-.877-.875H9a.874.874 0 0 0-.875.875v2A2.625 2.625 0 0 1 5.5 23.125h-1A2.625 2.625 0 0 1 1.875 20.5V15A6.126 6.126 0 0 1 8 8.876h2.507l.876-7.014.036-.171a1.125 1.125 0 0 1 2.016-.314l.667.999H17c.983 0 1.91.463 2.5 1.25l.561.75H21.5c.897 0 1.625.728 1.625 1.626z"
      />
    </svg>
  );
}
